<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="请选择代理商" class="handle-select mr10" style="width: 260px;">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" style="width: 260px" v-if="isAgent" v-model="query.companyId"
					@change="companyChange" filterable clearable placeholder="企业" class="handle-select mr10">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.status" filterable clearable placeholder="状态"
					class="handle-select mr10" style="width: 130px;">
					<el-option v-for="item in statusList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.riskTypeId" filterable clearable placeholder="风险类型"
					class="handle-select mr10" style="width: 130px;">
					<el-option v-for="item in riskTypeList" :key="item.value" :label="item.value"
						:value="item.label"></el-option>
				</el-select>
				<el-select size="small" v-model="query.operation" filterable clearable placeholder="核查类型"
					class="handle-select mr10" style="width: 130px;">
					<el-option v-for="item in operationList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.riskGradeId" filterable clearable placeholder="风险等级"
					class="handle-select mr10" style="width: 130px;">
					<el-option v-for="item in riskGradeList" :key="item.value" :label="item.value"
						:value="item.label"></el-option>
				</el-select>

				<el-select size="small" v-model="query.isUse" filterable clearable placeholder="是否核查"
					class="handle-select mr10" style="width: 130px;">
					<el-option v-for="item in isUseList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-date-picker v-model="timeArr" type="daterange" style="width: 230px;margin: 10px 10px 0 0;"
					unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
					@change="getTime()" size="small"></el-date-picker>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getData"
					style="margin: 10px 10px 0 0;">搜索</el-button>
			</div>
			<el-table v-loading="loading" :data="tableData" border class="table m_t_20"
				header-cell-class-name="table-header" :row-style="{ height: '20px' }"
				:header-cell-style="{ 'text-align': 'center' }" :cell-style="{ padding: '6px' }"
				:row-class-name="tableRowClassName">
				<el-table-column prop="agentName" label="代理商" align="center" width="140"
					show-overflow-tooltip></el-table-column>
				<el-table-column prop="companyName" label="企业" align="center" width="140"
					show-overflow-tooltip></el-table-column>
				<el-table-column prop="userPhone" label="主叫号码" align="center" width="120"></el-table-column>
				<el-table-column prop="phoneNumber" label="被叫号码" align="center" width="120"></el-table-column>
				<el-table-column prop="statusText" label="检测状态" align="center" width="100"></el-table-column>
				<el-table-column prop="riskType" label="风险类型" align="center" width="80"></el-table-column>
				<el-table-column prop="riskGrade" label="风险等级" align="center" width="80"></el-table-column>
				<el-table-column prop="isUse" label="是否核查" align="center" width="80">
					<template #default="scope">
						<el-tag type="danger" v-if="scope.row.isUse==false">未核查</el-tag>
						<el-tag type="success" v-if="scope.row.isUse==true">已核查</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="operation" label="核查类型" align="center" width="100">
					<template #default="scope">
						<el-tag type="success" v-if="scope.row.operation=='0'">无风险</el-tag>
						<el-tag type="danger" v-if="scope.row.operation=='1'">有风险</el-tag>
						<el-tag type="danger" v-if="scope.row.operation=='2'">有风险拉黑</el-tag>
						<el-tag type="danger" v-if="scope.row.operation=='3'">拉黑</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="riskContent" label="风险内容" align="center" width="120"
					show-overflow-tooltip></el-table-column>
				<el-table-column prop="content" label="检测内容" align="center" min-width="160">
					<template #default="scope">
						<el-tooltip placement="top">
							<div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
								{{ filteredContent(scope.row.content) }}
							</div>
							<template #content>
								<div style="max-width: 300px; white-space: pre-wrap;">
									{{ filteredContent(scope.row.content) }}
								</div>
							</template>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="updateTime" label="检测时间" align="center" width="155">
					<template #default="scope">
						{{toDateTimeStr(scope.row.updateTime)}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center" width="155">
					<template #default="scope">
						{{toDateTimeStr(scope.row.createTime)}}
					</template>
				</el-table-column>
				<el-table-column prop="user" label="操作者" align="center" width="100"></el-table-column>
				<el-table-column label="操作" align="center" width="120" fixed="right">
					<template #default="scope">
						<el-button size="small" type="primary" :class="[theme]"
							@click="getRecordingDetailsShow(scope.row)">录音详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="query.current"
					:page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="query.size" :total="pageTotal"
					@size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
			</div>
			<el-dialog title="录音详情" v-model="audioVisible" width="750px" @close="closeDialog"
				:close-on-click-modal="false">
				<audio-player ref="audio" class="audio-box" :fileurl="audioDetails.url" :row="audioDetails"
					:key="Audiotimer"></audio-player>
				<div style="padding: 20px;">{{ audioDetails.plainText }}</div>
				<div style="display: flex;flex-direction: row;justify-content: end;margin-top: 20px;"
					v-if="!audioDetails.isUse">
					<el-button size="small" type="primary" :class="[theme]" @click="getProcessing(0)">无风险</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getshowel(1)">标记风险</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getshowel(2)">标记拉黑</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getProcessing(3)">拉黑</el-button>
				</div>
			</el-dialog>
			<el-dialog title="标记风险" v-model="riskVisible" width="550px" @close="closeDialog2"
				:close-on-click-modal="false">
				<el-form :model="riskForm" :rules="rules" ref="riskForm" label-width="100px">
					<el-form-item label="风险原因:" prop="label">
						<el-radio-group v-model="riskForm.label">
							<el-radio v-for="item in riskList" :key="item.value" :label="item.label" :value="item.value"
								style="margin: 12px 6px;"></el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="备注:" prop="remark">
						<el-input size="small" v-model="riskForm.remark" placeholder="请输入备注"></el-input>
					</el-form-item>
					<el-form-item style="display: flex;flex-direction: row;justify-content: flex-end;">
						<el-button size="small" @click="closeDialog2">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]" @click="getProcessing2">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import {
		getCallQualityList,
		queryTypeOptions,
		processing
	} from '../api/inspection.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		fetchAgent
	} from '../api/agentIndex';
	import {
		querySubAgent
	} from '../api/serialIndex.js';
	import {
		riskCall
	} from '../api/setMeal';
	import {
		download
	} from '../api/recordIndex';
	import {
		AiRiskRecord
	} from '../api/index.js';
	import AudioPlayer from '../components/audioPlayer.vue';

	export default {
		name: 'telephoneInspectionList',
		components: {
			AudioPlayer
		},
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					current: 1,
					size: 10,
					status: '',
					agentId: '',
					companyId: '',
					riskTypeId: '',
					riskGradeId: '',
					startTime: '',
					endTime: '',
					operation: '',
					isUse: 0,
				},
				isAdmin: false,
				isAgent: false,
				currentRowId: null,
				role: '',
				agents: [],
				companys: [],
				pageTotal: 0,
				tableData: [],
				statusList: [{
						value: -1,
						label: '识别错误'
					},
					{
						value: 0,
						label: '待识别'
					},
					{
						value: 1,
						label: '识别中'
					},
					{
						value: 4,
						label: '质检完成'
					}
				],
				isUseList: [{
						value: 0,
						label: '全部'
					}, {
						value: 1,
						label: '已核查'
					},
					{
						value: 2,
						label: '未核查'
					}
				],
				riskTypeList: [],
				riskGradeList: [],

				audioVisible: false,
				audioDetails: {},
				Audiotimer: null,
				timeArr: [],
				riskVisible: false,
				riskForm: {
					dispose: false
				},
				operationList: [{
						label: '无风险',
						value: 0
					},
					{
						label: '有风险',
						value: 1
					},
					{
						label: '有风险拉黑',
						value: 2
					},
					{
						label: '拉黑',
						value: 3
					}
				],
				riskList: [{
						label: '诈骗',
						value: '诈骗'
					},
					{
						label: '辱骂',
						value: '辱骂'
					},
					{
						label: '违规',
						value: '违规'
					},
					{
						label: '报备话术不一致',
						value: '报备话术不一致'
					},
					{
						label: '有投诉风险',
						value: '有投诉风险'
					},
					{
						label: '其他',
						value: '其他'
					}
				],
				risk: ''
			};
		},
		created() {
			this.init();
			this.getTime();
			this.role = localStorage.getItem('ms_role');
			if (this.role === 'agent') {
				this.isAgent = true;
			}

			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isAgent = true;
				this.getData();
			}
			this.getQueryTypeOptions();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			filteredContent(content) {
				if (!content) return '';
				return content.replace(/<\|.*?\|>/g, '');
			},
			getTime() {
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},

			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				if (this.subAgent == true) {
					this.isSubAgent = true;
					this.getquerySubAgent();
				}
				this.getfetchDefaultCompanies();
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			getquerySubAgent() {
				let data = {
					agentId: this.query.agentId,
					userId: localStorage.getItem('user')
				};
				querySubAgent(data).then(res => {
					if (res?.code === 200) {
						this.subAgentList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getData() {
				this.query.startTime = this.toDateTimeStr2(this.timeArr[0]);
				this.query.endTime = this.toDateTimeStr2(this.timeArr[1]);
				this.loading = true;
				getCallQualityList(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.records;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getQueryTypeOptions() {
				let data = {
					type_id: '',
				}
				queryTypeOptions(data).then(res => {
					if (res?.code === 200) {
						this.riskTypeList = res.data.riskTypeOptions;
						this.riskGradeList = res.data.riskGradeOptions;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 分页导航
			handlePageChange(val) {
				this.query.current = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.query.current = 1; // 重置到第一页
				this.getData();
			},
			toDateTimeStr(dateTime) {
				let date = new Date(dateTime);
				// 使用Date对象的方法来获取年月日时分秒
				let year = date.getFullYear();
				let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以需要+1，并用'0'填充
				let day = String(date.getDate()).padStart(2, '0');
				let hours = String(date.getHours()).padStart(2, '0');
				let minutes = String(date.getMinutes()).padStart(2, '0');
				let seconds = String(date.getSeconds()).padStart(2, '0');
				// 拼接成完整的日期时间字符串
				let formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				return formattedDateTime;
			},
			toDateTimeStr2(dateTime) {
				let date = new Date(dateTime);
				// 使用Date对象的方法来获取年月日时分秒
				let year = date.getFullYear();
				let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以需要+1，并用'0'填充
				let day = String(date.getDate()).padStart(2, '0');
				// 拼接成完整的日期时间字符串
				let formattedDateTime = `${year}-${month}-${day}`;
				return formattedDateTime;
			},
			closeDialog() {
				if (this.$refs.audio) {
					this.$refs.audio.pauseAudioExternally();
				}
				this.audioVisible = false;
			},
			getRiskCall() {
				let data = {
					phones: this.audioDetails.phoneNumber,
					userId: localStorage.getItem('user')
				}
				riskCall(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.audioVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getRecordingDetailsShow(row) {
				this.currentRowId = row.id;
				this.audioVisible = true;
				this.audioDetails = row;
				this.Audiotimer = new Date().getTime();
			},
			tableRowClassName({
				row
			}) {
				return row.id === this.currentRowId ? 'active-row' : '';
			},
			getProcessing(risk) {
				let data = {
					id: this.audioDetails.id,
					risk: risk,
				};
				processing(data).then(res => {
					if (res?.code === 200) {
						if (this.$refs.audio) {
							this.$refs.audio.pauseAudioExternally();
						}
						this.audioVisible = false;
						this.$message.success(res.data);
						this.getData();
					} else {
						this.$message.success(res.message);
					}
				});
			},
			getProcessing2() {
				let data = {
					id: this.audioDetails.id,
					risk: this.risk,
					remark: this.riskForm.remark,
					label: this.riskForm.label
				};
				processing(data).then(res => {
					if (res?.code === 200) {
						this.audioVisible = false;
						this.riskVisible = false;
						this.$message.success(res.data);
						this.getData();
					} else {
						this.$message.success(res.message);
					}
				});
			},
			getshowel(risk) {
				this.risk = risk;
				this.riskForm.remark = '';
				this.riskVisible = true;
			},

			closeDialog2() {
				this.riskVisible = false;
				this.riskForm.remark = '';
			},
		}
	};
</script>

<style scoped>
	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	/deep/.el-table__body .active-row {
		background-color: #dfd9e0 !important;
	}
</style>